export default {
  install (Vue) {
    Vue.directive('smooth-scroll', {
      inserted (el, binding) {
        if (typeof window !== 'object' || window.scrollY === void 0) return

        el.addEventListener('click', function (ev) {
          let scrollTo = document.getElementById(this.hash.substring(1))
          if (!scrollTo) return

          ev.preventDefault()

          const duration = binding.value && binding.value.duration
            ? binding.value['duration']
            : 450

          const offset = binding.value && binding.value.offset
            ? binding.value['offset']
            : 0

          const clock = Date.now()

          let end = scrollTo.nodeName === 'HTML' ? -window.scrollY : scrollTo.getBoundingClientRect().top + window.scrollY

          end += offset

          const requestAnimationFrame = window.requestAnimationFrame ||
            window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
            function (fn) { window.setTimeout(fn, 15) }

          const step = () => {
            const elapsed = Date.now() - clock
            let position = end
            if (elapsed < duration) {
              position = window.scrollY + (end - window.scrollY) * easeInOutCubic(elapsed / duration)
              requestAnimationFrame(step)
            }
            window.scroll(0, position)
          }
          step()
        })
      }
    })
  }
}

function easeInOutCubic (t) {
  return t < 0.5
    ? 2 * t * t * t
    : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
}



// WEBPACK FOOTER //
// ./src/directives/vue-smooth-scroll.js